import useCommonCustomerQuery from "@repo/shopify/queries/useCustomerQuery";

import useLanguage from "@hooks/useLanguage";
import useSessionExpired from "@hooks/useSessionExpired";

import { useCustomerStore } from "@store/customer";
import { useLayoutStore } from "@store/layout";

export default function useCustomer() {
  const onSessionExpired = useSessionExpired();

  const { update, token } = useCustomerStore();
  const { openToast } = useLayoutStore();

  const { lang } = useLanguage();

  return useCommonCustomerQuery({
    lang,
    accessToken: token.accessToken,
    update,
    openToast,
    onSessionExpired,
  });
}
